import React from "react";
import { BookAppointment } from "../common/BookAppointment";
import { BookingCard } from "../common/BookingCard";
import management from "../../../../common/utilities/Management";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../common/state/model/ApplicationState";

export function Step35(): React.JSX.Element {
  const allowHealthInformationOnTreatment = useSelector((state: ApplicationState) => state.common?.config?.allowHealthInformationOnTreatment);

  return (
    <BookingCard>
      <BookAppointment
        currentStepId={"35"}
        showMedicalInformation={management.partnerAdapter.showMedicalInformationForTreatmentPlan(allowHealthInformationOnTreatment)}
      />
    </BookingCard>
  );
}
